import { map } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { GlobalService } from '../shared/services/global.service';
import { Observable, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

export interface TranslatableItem {
  id: number;
  name: string;
  name_eng?: string;
  name_esp?: string;
  name_pt?: string;
}

export interface FiltersDataResponse {
  scene_types?: TranslatableItem[];
  scene_statuses?: TranslatableItem[];
  scene_loc_std_options?: TranslatableItem[];
  scene_day_night_options?: TranslatableItem[];
  scene_interior_exterior_options?: TranslatableItem[];
  chapters?: Array<{ id: number; number: string; name: string }>;
  locations?: Array<{ id: number; location_name: string }>;
  location_sets?: Array<{ id: number; set_name: string; location_id: number }>;
  characters?: Array<{ id: number; character_name: string; character_role_id: number }>;
  elements?: Array<{ id: number; element_name: string; element_category_id: number }>;
  element_categories?: TranslatableItem[];
  event_types?: TranslatableItem[];
  scene_protection_types?: TranslatableItem[];
  units?: Array<{ id: number; unit_name: string }>;
  tentatives?: Array<{ name_tentative: string }>;
}

export type FilterType =
  | 'scene_types'
  | 'scene_statuses'
  | 'scene_loc_std_options'
  | 'scene_day_night_options'
  | 'scene_interior_exterior_options'
  | 'chapters'
  | 'locations'
  | 'location_sets'
  | 'characters'
  | 'elements'
  | 'element_categories'
  | 'event_types'
  | 'scene_protection_types'
  | 'units'
  | 'tentatives'
	| 'character_roles';

@Injectable({
	providedIn: 'root'
})
export class ProjetcsService {

	private cache: any = {}
	private subjectLiveView$ = new BehaviorSubject<any>({});

	setDataLiveView(data: any) {
		this.subjectLiveView$.next(data);
	}

	getDataLiveView(): Observable<any> {
		return this.subjectLiveView$.asObservable();
	}

	isCreatedAfterPublished(section, req) {
		if (!section) return false;
		let staticHourPublished = this._gS.getStaticDateHour(section.created_at);
		let staticHourReq = this._gS.getStaticDateHour(req.created_at);
		return staticHourReq > staticHourPublished;
	}

	//remove_calendar_event
	saveWeekProjection(week_id, projected_chapters, projected_scenes, projected_minutes) {
		let data = {
			session_id: this._gS.session_token,
			week_id: week_id,
			projected_chapters: projected_chapters,
			projected_scenes: projected_scenes,
			projected_minutes: projected_minutes
		};
		return this.http.post(this._gS.service_url + 'projects/save_production_plan', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	productionPlanData(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'projects/production_plan_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	removeCalendarEvent(event_id, type) {
		let data = {
			session_id: this._gS.session_token,
			id: event_id,
			type: type
		};
		return this.http.post(this._gS.service_url + 'projects/remove_calendar_event', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveCalendarEvent(id, char_loc_id, date_from, date_to, type, description, unit_id, unit_event_id, values) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			char_loc_id: char_loc_id,
			date_from: date_from,
			date_to: date_to,
			type: type,
			description: description,
			project_id: this._gS.projectSelected.id,
			unit_event_id: unit_event_id,
			unit_id: unit_id,
			country_id: values.country_id ? values.country_id : null
		};
		return this.http.post(this._gS.service_url + 'projects/add_calendar_event', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	saveHoliday(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			date_from: values.date_from,
			date_to: values.date_to,
			type: values.type,
			description: values.description,
			country_id: values.country_id,
			all_years: values.all_years
		};
		return this.http.post(this._gS.service_url + 'projects/add_calendar_event', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getCalendarEventData(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'projects/calendar_event_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getCalendar(project_id, date) {
		const dateToSend = date ? this._dP.transform(date, 'yyyy-MM-dd') : null;
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			date: dateToSend
		};
		return this.http.post(this._gS.service_url + 'projects/get_calendar', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getDashboardParameters(project_id) {
		//get_total_weeks
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'dashboard/get_parameters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getTotalWeeks(project_id) {
		//get_total_weeks
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'dashboard/get_total_weeks', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	GetDailyShootings(project_id, date, type) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			date: date,
			type: type
		};
		return this.http.post(this._gS.service_url + 'dashboard/get_shootings_day', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	reverseShooting(shooting_id, name_tentative) {
		// reverse_shooting
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			name_tentative: name_tentative
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/reverse_shooting', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	linkScenes(sh_sch_has_scene_id, link_scenes_ids) {
		let data = {
			session_id: this._gS.session_token,
			sh_sch_has_scene_id: sh_sch_has_scene_id,
			link_scenes_ids: link_scenes_ids
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/link_scenes', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteClip(clip_id) {
		let data = {
			session_id: this._gS.session_token,
			id: clip_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_clip', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveShootingClip(formData) {
		let data = {
			session_id: this._gS.session_token,
			formData: formData
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/add_clip_to_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getClipsData(sh_sch_has_scene_id) {
		let data = {
			session_id: this._gS.session_token,
			sh_sch_has_scene_id: sh_sch_has_scene_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/get_add_clip_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	copyCrewCall(shooting_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/copy_previuos_crew', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteSetContinuity(continuity_set_image_id) {
		let data = {
			session_id: this._gS.session_token,
			continuity_set_image_id: continuity_set_image_id
		};
		return this.http.post(this._gS.service_url + 'continuity/delete_set_continuity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteContinuity(continuity_image_id) {
		let data = {
			session_id: this._gS.session_token,
			continuity_image_id: continuity_image_id
		};
		return this.http.post(this._gS.service_url + 'continuity/delete_continuity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteSceneContinuity(continuity_scene_image_id) {
		let data = {
			session_id: this._gS.session_token,
			continuity_scene_image_id: continuity_scene_image_id
		};
		return this.http.post(this._gS.service_url + 'continuity/delete_scene_continuity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	replaceImageContinuity(image, projectId) {
		let data = {
			session_id: this._gS.session_token,
			id: image.id,
			image: image.base64,
			route: `${projectId}/continuity`
		};
		return this.http.post(this._gS.service_url + 'continuity/replace_image', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getContinuityData(project_id) {
		return this.http.get(this._gS.service_url + 'continuity/get_continuity_data', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('project_id', project_id)
		})
	}
	getContinuityImages(project_id, character_id?, day_history?, from?, department_id?) {
		console.log("herwe we are")
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			character_id: character_id,
			day_history: day_history,
			from: from,
			department_id: department_id

		};
		return this.http.post(this._gS.service_url + 'continuity/get_continuity_images', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getContinuitySetData(project_id) {
		return this.http.get(this._gS.service_url + 'continuity/get_location_continuity_data', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('project_id', project_id)
		})
	}
	getContinuitySetImages(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'continuity/get_continuity_set_images', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getContAddImageData(project_id) {
		return this.http.get(this._gS.service_url + 'continuity/get_add_image_data', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('project_id', project_id)
		})
	}

	getContinuityCharacters(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'continuity/get_continuity_characters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getContinuityCharacterDetail(character_id) {
		let data = {
			session_id: this._gS.session_token,
			character_id: character_id
		};
		return this.http.post(this._gS.service_url + 'continuity/get_continuity_character_id', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getContinuityDayOfHistory(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'continuity/get_day_of_history', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getContinuityCharacterDayOfHistory(project_id, day_history) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			day_history: day_history
		};
		return this.http.post(this._gS.service_url + 'continuity/get_character_day_of_history', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	saveSetContinuity(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			department_id: values.department_id,
			location_set_id: values.location_set_id,
			image_url: values.image_url,
			tittle: values.tittle,
			is_prop: values.type_id == '4' ? true : false
		};
		return this.http.post(this._gS.service_url + 'continuity/create_set_continuity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveContinuity(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			department_id: values.department_id,
			character_id: values.character_id,
			day_of_history: values.day_of_history,
			image_url: values.image_url,
			tittle: values.tittle,
			is_prop: values.type_id == '2' ? true : false
		};
		return this.http.post(this._gS.service_url + 'continuity/create_continuity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveParameters(project_id, parameters, units, countries, type, trips = null) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			parameters: parameters,
			units: units,
			countries: countries,
			type: type,
			trips: trips
		};
		return this.http.post(this._gS.service_url + 'projects/save_parameters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getParameters(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'projects/get_parameters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addUnit(project_id, units) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			units: units
		};
		return this.http.post(this._gS.service_url + 'projects/add_units', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveShootingLog(shooting_id, log_data) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			shooting_log_id: log_data.id,
			event_time: log_data.event_time,
			event_description: log_data.event_description
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_shooting_log', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	publishTentaiveShooting(shooting_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/publish_tentative', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteShootingLog(shooting_log_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_log_id: shooting_log_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_shooting_log', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	unassignScene(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/unassign_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addShootingComment(shooting_id, id, comment, include_call, include_as_general) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			comment: comment,
			include_call: include_call ? 1 : undefined,
			include_as_general: include_as_general ? 1 : undefined,
			id: id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/add_comment', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteShootingComment(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_comment', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteShootingRadio(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_shooting_radio', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	createShootingRadio(shooting_id, values) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			values: values
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/create_shooting_radio', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveCateringCall(id, type, value) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			type: type,
			value: value
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_catering_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	createCateringCall(id, values) {
		values.id = id;
		let data = {
			session_id: this._gS.session_token,
			values: values,
			shooting_id: values.shooting_id,
			project_id: values.project_id ? values.project_id : null,
			date: values.date,
			unit_id: values.unit_id ? values.unit_id : null,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/create_catering_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteCateringCall(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_catering_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createCrewCall(shooting_id, values) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			values: values,
			on_call: values.on_call ? 1 : undefined
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/create_crew_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveCrewCallTime(shooting_id, type, id, value, on_call?) {
		let data = {
			session_id: this._gS.session_token,
			type: type,
			id: id,
			value: value,
			on_call: on_call ? 1 : undefined
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_crew_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteCrewCall(ev) {
		let data = {
			session_id: this._gS.session_token,
			id: ev
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_crew_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deletRequirmentCall(call_id) {
		let data = {
			session_id: this._gS.session_token,
			call_id: call_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_requirement_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deletCall(call_id, scenes, character_id) {
		let data = {
			session_id: this._gS.session_token,
			call_id: call_id ? call_id : null,
			scenes_ids: scenes ? scenes : null,
			character_id: character_id ? character_id : null
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_talent_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	newTalentCall(shooting_id, values) {
		let data = {
			session_id: this._gS.session_token,
			values: values,
			shooting_id: shooting_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/new_talent_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addTalentCallData(project_id, shooting_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			shooting_id: shooting_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/add_talent_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getCrewCallData() {
		let data = {
			session_id: this._gS.session_token,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/get_crew_call_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingSaveHospital(shooting_id, values) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			nearest_hospital_id: values?.nearest_hospital_id,
			hospital_name: values.hospital_name,
			address: values.address,
			unit: values.unit,
			city: values.city,
			state_id: values.state_id,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_hospital', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingSavePhysical(shooting_id, values) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			values: values
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_physical', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingCreateRequimentCall(id, values) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			shooting_id: values.shooting_id,
			date: values.date,
			unit_id: values.unit_id ? values.unit_id : null,
			project_id: values.project_id ? values.project_id : null,
			values: values
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/create_requirment_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingSaveRequimentCall(shooting_id, type, item, value) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			type: type,
			id: item.id,
			value: value

		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_requirment_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingSaveCall(shooting_id, type, values, time) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			type: type,
			values: values,
			time: time

		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_talent_time', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingDeletePhysical(physical_id,) {
		let data = {
			session_id: this._gS.session_token,
			id: physical_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_physical_location', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingDeleteAdvance(advance_id,) {
		let data = {
			session_id: this._gS.session_token,
			id: advance_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_advance_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingSaveAdvance(shooting_id, values) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			values: values
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_advance_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingSaveTime(shooting_id, type, time) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			type: type,
			time: time
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_time', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	shootingSaveOrder(scenes) {
		let data = {
			session_id: this._gS.session_token,
			scenes: scenes
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_order', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getWeekShootings(project_id, date, tentative) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			date: date,
			tentative: tentative
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/get_week_shootings', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getShooting(project_id, order) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order: order
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/get_shootings', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	changeStatus(shooting_id, status_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			status_id: status_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/change_status', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	changeShootingStatus(shooting_id, status_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			status_id: status_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/change_status', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteShooting(shooting_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_shooting', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	moveShooting(shooting) {
		let data = {
			session_id: this._gS.session_token,
			shooting: shooting
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/move_shooting', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getShootingDetail(shooting_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/get_shooting_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getShootingSceneDetail(shooting_scene_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_scene_id: shooting_scene_id
		};
		return this.http.post(this._gS.service_url + 'scenes/get_shooting_scene_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveShootingTime(shooting_scene_id, sh_scn_time_id, values) {
		let data = {
			session_id: this._gS.session_token,
			sh_scn_time_id: sh_scn_time_id,
			shooting_scene_id: shooting_scene_id,
			values: values
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_shooting_time', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveProducedTime(shooting_scene_id, produced_seconds, partially_shot) {
		let data = {
			session_id: this._gS.session_token,
			shooting_scene_id: shooting_scene_id,
			produced_seconds: produced_seconds,
			partially_shot: partially_shot
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_produce_time', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveShootingNotes(shooting_scene_id, notes) {
		let data = {
			session_id: this._gS.session_token,
			shooting_scene_id: shooting_scene_id,
			notes: notes
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_shooting_notes', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	unproducedScene(shooting_scene_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_scene_id: shooting_scene_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/unproduced_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	releaseScene(shooting_scene_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_scene_id: shooting_scene_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/release_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	unreleaseScene(shooting_scene_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_scene_id: shooting_scene_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/unrelease_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getProjects() {
		let data = {
			session_id: this._gS.getSeesion()
		};
		return this.http.post(this._gS.service_url + 'projects/list_projects', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getProdWeeks(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'projects/production_get_weeks', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getProjectData(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'projects/get_project_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getProjectHomeData(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'projects/project_home_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getProjectTotals(project_id) {
		return this.http.get(this._gS.service_url + 'projects/get_project_domestic', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('project_id', project_id)
		})
	}
	getAnnotationsDetail(chapter_file_id) {
		return this.http.get(this._gS.service_url + 'chapters/get_annotations_detail', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('chapter_file_id', chapter_file_id)
		})
	}
	getChapters(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'chapters/get_chapters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getColorBox(project_id, filterArguments?: any) {
		// get_color_box
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			chapter_id: filterArguments?.chapter,
			scene_id: filterArguments?.scene
		};
		return this.http.post(this._gS.service_url + 'chapters/get_color_box', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getChaptersParameters(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'chapters/get_chapters_parameters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	// receive_chapter
	receiveChapterOLD(values, xmltext) {
		let data = {
			session_id: this._gS.session_token,
			// values: values,
			chapter_id: values.chapter_id,
			received_date: values.received_date,
			version: values.version,
			modification: values.modification,
			comment: values.comment,
			route: values.route,
			xmltext: xmltext
		};
		return this.http.post(this._gS.service_url + 'chapters/receive_chapter', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	receiveChapter(values, file) {
		let url_service = this._gS.service_url + 'chapters/receive_chapter'
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('added_scene', values.added_scene)
		formData.append('chapter_id', values.chapter_id)
		formData.append('received_date', values.received_date)
		formData.append('version', values.version)
		formData.append('modification', values.modification)
		formData.append('comment', values.comments)
		formData.append('pages', values.pages);
		// formData.append('xmltext',xmltext);
		formData.append('file', file);
		return this.http
			.post(url_service, formData)
			.pipe(map((response: Response) => response))
	}
	getChapterdata(chapter_id) {
		let data = {
			session_id: this._gS.session_token,

			chapter_id: chapter_id
		};
		return this.http.post(this._gS.service_url + 'chapters/chapter_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	publishChapter(chapter_id) {
		let data = {
			session_id: this._gS.session_token,
			chapter_id: chapter_id
		};
		return this.http.post(this._gS.service_url + 'chapters/publish_chapter', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}
	deliverChapter(chapter_id) {
		let data = {
			session_id: this._gS.session_token,
			chapter_id: chapter_id
		};
		return this.http.post(this._gS.service_url + 'chapters/deliver_chapter', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}
	add_version_comment(chapter_file_id, comment) {
		let data = {
			session_id: this._gS.session_token,
			chapter_file_id: chapter_file_id,
			comment: comment
		};
		return this.http.post(this._gS.service_url + 'chapters/add_version_comment', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteVerionComment(comment_id) {
		let data = {
			session_id: this._gS.session_token,
			comment_id: comment_id
		};
		return this.http.post(this._gS.service_url + 'chapters/delete_version_comment', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addSceneComment(scene_id, comment_id, comment) {
		let data = {
			session_id: this._gS.session_token,
			scene_id: scene_id,
			comment_id: comment_id,
			comment: comment
		};
		return this.http.post(this._gS.service_url + 'scenes/save_comment', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteSceneComment(comment_id) {
		let data = {
			session_id: this._gS.session_token,
			comment_id: comment_id
		};
		return this.http.post(this._gS.service_url + 'scenes/delete_comment', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveScenes(values, scenes, file_name) {
		let data = {
			session_id: this._gS.session_token,
			values: values,
			scenes: scenes,
			file_name: file_name
		};
		return this.http.post(this._gS.service_url + 'chapters/save_scenes', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getScenesStoredData(project_id, reload = false) {
		const cacheKey = `get_scenes_data_${project_id}`
		let subs: Subscription;

		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
		};


		if (reload) {
			this.cache[cacheKey] = null;
		}

		return new Observable(observer => {
			if (!_.isEmpty(this.cache[cacheKey])) {
				observer.next(this.cache[cacheKey])
			} else {
				subs = this.http.post(this._gS.service_url + 'scenes/get_scenes_data', data, this._gS.httpOptions).pipe(
					map((response: Response) => response))
					.subscribe(response => {
						this.cache[cacheKey] = response
						observer.next(this.cache[cacheKey])
					})
			}

			return {
				unsubscribe() {
					if (subs)
						subs.unsubscribe()
				}
			}
		})
	}

	// Scenes services
	getScenesData(project_id) {

		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
		};


		return this.http.post(this._gS.service_url + 'scenes/get_scenes_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getFiltersData(
		projectId: number,
		onlyFilters?: FilterType[]
	): Observable<FiltersDataResponse> {
	let params = new HttpParams()
		.set('project_id', projectId.toString())
		.set('session_id', this._gS.session_token);

	if (onlyFilters && onlyFilters.length > 0) {
		params = params.set('only', onlyFilters.join(','));
	}

	return this.http.get<FiltersDataResponse>(this._gS.service_url + '/scenes/get_filters_data', { params });
	}

  getAllFiltersData(projectId: number): Observable<FiltersDataResponse> {
    return this.getFiltersData(projectId);
  }

	getListVideoClipsScene(scene_id) {
		return this.http.get(this._gS.service_url + 'scenes/list_video_clips_scene', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('scene_id', scene_id)
		})
	}

	getListContinuityImagesScene(scene_id) {
		return this.http.get(this._gS.service_url + 'continuity/get_continuity_scene_detail', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('scene_id', scene_id)
		})
	}
	getScenesIds(project_id, order, chapter_id, filters?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			chapter_id: chapter_id,
			order: order,
			filters: filters
		};
		return this.http.post(this._gS.service_url + 'scenes/get_scenes_ids', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getScenesList(project_id, order, chapter_id, filters?, page?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			chapter_id: chapter_id,
			order: order,
			filters: filters,
			page: page
		};
		return this.http.post(this._gS.service_url + 'scenes/get_scenes_list', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getChaptersScenes(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'scenes/chapters_scenes_list', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	createScene(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values
		};
		return this.http.post(this._gS.service_url + 'scenes/create_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	cancelScene(scene_id) {
		let data = {
			session_id: this._gS.session_token,
			scene_id: scene_id
		};
		return this.http.post(this._gS.service_url + 'scenes/cancel_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	uncancelScene(scene_id) {
		let data = {
			session_id: this._gS.session_token,
			scene_id: scene_id
		};
		return this.http.post(this._gS.service_url + 'scenes/uncancel_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteScene(scene_id) {
		let data = {
			session_id: this._gS.session_token,
			scene_id: scene_id
		};
		return this.http.post(this._gS.service_url + 'scenes/delete_scene', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	bulkDeleteScenes(scenes_ids) {
	    let data = {
			session_id: this._gS.session_token,
			scenes_ids: scenes_ids
		}
		return this.http.post(this._gS.service_url + 'scenes/bulk_delete_scenes', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	bulkCancelScenes(scenes_ids) {
		let data = {
			session_id: this._gS.session_token,
			scenes_ids: scenes_ids
		}
		return this.http.post(this._gS.service_url + 'scenes/bulk_cancel_scenes', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	AssignScenes(unit_id, date, scenes, is_tentative, name_tentative) {
		let data = {
			session_id: this._gS.session_token,
			unit_id: unit_id,
			date: date,
			is_tentative: is_tentative,
			name_tentative: name_tentative,
			scenes: scenes
		};
		return this.http.post(this._gS.service_url + 'scenes/create_shooting_schedule', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getSceneDetail(scene_id) {
		let data = {
			session_id: this._gS.session_token,
			scene_id: scene_id,
		};
		return this.http.post(this._gS.service_url + 'scenes/get_scene_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	charactersInChapters(project_id, ids = [], filter = null) {	
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id, 
			ids: ids,
			filter: filter
		};
		return this.http.post(this._gS.service_url + 'characters/characters_in_chapters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addTalent(character_id, character_has_talent_id, talent_form) {
		let data = {
			session_id: this._gS.session_token,
			character_id: character_id,
			character_has_talent_id: character_has_talent_id,
			talent_form: talent_form
		};
		return this.http.post(this._gS.service_url + 'characters/add_talent', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getTalent(talent_id) {
		let data = {
			session_id: this._gS.session_token,
			talent_id: talent_id
		};
		return this.http.post(this._gS.service_url + 'characters/get_talent', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	removeTalent(character_has_talent_id) {
		let data = {
			session_id: this._gS.session_token,
			character_has_talent_id: character_has_talent_id
		};
		return this.http.post(this._gS.service_url + 'characters/remove_talent', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	listCharacters(
		project_id: string, 
		order_by: any, 
		page: number = 1, 
		per_page: number = 30, 
		filters?: any,
		additionalInfo: boolean = true,
		searchText: string = ''
	): Observable<any> {
		const data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by,
			page: page,
			per_page: per_page,
			filters: filters,
			additional_info: additionalInfo,
			search_text: searchText
		};
	
		return this.http.post(this._gS.service_url + 'characters/list_characters', data, this._gS.httpOptions).pipe(
			map((response: any) => response)
		);
	}
	listAllCharacters(
		project_id: string, 
		order_by?: any, 
		additionalInfo: boolean = false
	): Observable<any> {
		return this.listCharacters(project_id, order_by, undefined, undefined, undefined, additionalInfo);
	}
	editCharacter(character_id, values) {
		let data = {
			session_id: this._gS.session_token,
			character_id: character_id,
			values: values
		};
		return this.http.post(this._gS.service_url + 'characters/edit_character', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	mergeCategoryElements(values, project_id) {
		let data = {
			'session_id': this._gS.session_token,
			'element_category_id': values.element_category_id,
			'element_categories': values.categories.map(l => l.id),
			'project_id': project_id
		};
		return this.http.post(this._gS.service_url + 'elements/merge_element_category', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	mergeRoles(values, project_id) {
		let data = {
			'session_id': this._gS.session_token,
			'character_role_id': values.character_role_id,
			'character_rols': values.roles.map(l => l.id),
			'project_id': project_id
		};
		return this.http.post(this._gS.service_url + 'characters/merge_character_rol ', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	mergeCharacters(values, project_id) {
		let data = {
			'session_id': this._gS.session_token,
			'character_id': values.character_id,
			'characters': values.characters.map(l => l.id),
			'project_id': project_id
		};
		return this.http.post(this._gS.service_url + 'characters/merge_characters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	mergeElements(values, project_id) {
		let data = {
			'session_id': this._gS.session_token,
			'element_id': values.element_id,
			'elements': values.elements.map(l => l.id),
			'project_id': project_id
		};
		return this.http.post(this._gS.service_url + 'elements/merge_elements', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	mergeLocations(values, project_id) {
		let data = {
			'session_id': this._gS.session_token,
			'location_id': values.location_id,
			'locations': values.locations.map(l => l.id),
			'project_id': project_id
		};
		return this.http.post(this._gS.service_url + 'locations/merge_locations', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	mergeSelectedSet(values, project_id) {
		let data = {
			'session_id': this._gS.session_token,
			'set_id': values.set_id,
			'sets': values.sets.map(l => l.id),
			'project_id': project_id
		};
		return this.http.post(this._gS.service_url + 'sets/merge_selected_sets', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	cancelCharacter(character_id) {
		let data = {
			session_id: this._gS.session_token,
			character_id: character_id
		};
		return this.http.post(this._gS.service_url + 'characters/delete_character', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	// sets
	setsInChapters(project_id, ids = []) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			ids: ids
		};
		return this.http.post(this._gS.service_url + 'sets/sets_in_chapters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}
	listSets(project_id, order_by) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by
		};
		return this.http.post(this._gS.service_url + 'sets/get_sets', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	mergeSets(location_set_from_id, location_set_to_id) {
		// merge_sets
		let data = {
			session_id: this._gS.session_token,
			location_set_from_id: location_set_from_id,
			location_set_to_id: location_set_to_id
		};
		return this.http.post(this._gS.service_url + 'sets/merge_sets', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	editSets(location_set_id, location_id, set_name, scene_location_studio_option_id) {
		let data = {
			session_id: this._gS.session_token,
			location_set_id: location_set_id,
			location_id: location_id,
			set_name: set_name,
			scene_location_studio_option_id: scene_location_studio_option_id
		};
		return this.http.post(this._gS.service_url + 'sets/edit_set', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteSets(location_set_id) {
		let data = {
			session_id: this._gS.session_token,
			location_set_id: location_set_id
		};
		return this.http.post(this._gS.service_url + 'sets/delete_set', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	//
	locationsInChapters(project_id, ids) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			ids: ids
		};
		return this.http.post(this._gS.service_url + 'locations/locations_in_chapters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}
	listAllLocations(project_id: string, order_by?: any): Observable<any> {
		const data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by || ['location_name'],
			all: true
		};
	
		return this.http.post(this._gS.service_url + 'locations/get_locations', data, this._gS.httpOptions);
	}
	
	listLocations(project_id, order_by, page?: number, per_page?: number, filters?: any, searchText?: string) {
		let data: any = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by,
			filters: filters,
			search_text: searchText
		};
	
		if (page !== undefined) {
			data.page = page;
			data.per_page = per_page || 30;
		}
	
		return this.http.post(this._gS.service_url + 'locations/get_locations', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	editLocation(location_id, location_name) {
		let data = {
			session_id: this._gS.session_token,
			location_id: location_id,
			location_name: location_name
		};
		return this.http.post(this._gS.service_url + 'locations/edit_location', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	editLocationAddress(location_id, location_address, location_lat, location_lng) {
		let data = {
			session_id: this._gS.session_token,
			location_id: location_id,
			location_address: location_address,
			location_lat: location_lat,
			location_lng: location_lng
		};

		return this.http.post(this._gS.service_url + 'locations/edit_location_address', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteLocationAddress(location_id) {
		let data = {
			session_id: this._gS.session_token,
			location_id: location_id
		};

		return this.http.post(this._gS.service_url + 'locations/delete_location_address', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleLelocation(location_id) {
		let data = {
			session_id: this._gS.session_token,
			location_id: location_id
		};
		return this.http.post(this._gS.service_url + 'locations/delete_location', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

  deleteLocationImage(locationImageId){
    let data = {
      session_id: this._gS.session_token,
      location_image_id: locationImageId
    }
    return this.http.post(this._gS.service_url + 'locations/delete_location_image', data, this._gS.httpOptions).pipe(
      map((response: Response) => response))
  }
	listRoles(project_id, order_by) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by
		};

		return this.http.post(this._gS.service_url + 'characters/get_character_rol', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	editRoles(character_role_id , character_role_eng, character_role_esp, character_role_pt, project_id, useQuantity: boolean) {
		let data = {
			session_id: this._gS.session_token,
			character_role_id: character_role_id,
			character_role_eng: character_role_eng,
			character_role_esp: character_role_esp,
			character_role_pt: character_role_pt,
			project_id,
			use_quantity: useQuantity
		};

		return this.http.post(this._gS.service_url + 'characters/create_character_role', data, this._gS.httpOptions).pipe(
			map((response: Response) => response));
	}
	deleLeRoles(character_role_id ) {
		let data = {
			session_id: this._gS.session_token,
			character_role_id : character_role_id 
		};

		return this.http.post(this._gS.service_url + 'characters/delete_character_rol', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	listCategoryElements(project_id, order_by) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by
		};

		return this.http.post(this._gS.service_url + 'elements/get_element_category', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	editCategoryElements(element_category_id , element_category_eng, element_category_esp, element_category_pt, project_id) {
		let data = {
			session_id: this._gS.session_token,
			element_category_id: element_category_id,
			element_category_eng: element_category_eng,
			element_category_esp: element_category_esp,
			element_category_pt: element_category_pt,
			project_id
		};
		
		return this.http.post(this._gS.service_url + 'elements/create_element_category', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleLeCategoryElements(element_category_id) {
		let data = {
			session_id: this._gS.session_token,
			element_category_id : element_category_id 
		};
		
		return this.http.post(this._gS.service_url + 'elements/delete_element_category', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	elementsInChapters(project_id, type) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			type: type
		};
		return this.http.post(this._gS.service_url + 'elements/elements_in_chapters', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	listElements(project_id, order_by, show_all = false, currentPage = 1, bringElementsOutOfDay = true,  filters?: any, search_text?: string, ) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by,
			page: currentPage,
			show_all: show_all,
			bring_elements_out_of_day: bringElementsOutOfDay,
			filters: filters,
			search_text: search_text
		};

		return this.http.post(this._gS.service_url + 'elements/get_elements', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addBrand(brand_id, project_id, scene_id, values) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			brand_id: brand_id,
			brand_name: values.element_name,
			description: values.description,
			ubication: values.ubication,
			scene_id: scene_id ? scene_id : undefined
		};
		return this.http.post(this._gS.service_url + 'elements/add_brand', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addImageToBrand(file, scene_id, element_id, isOriginalDesign) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		if (scene_id) {
			formData.append('scene_id', scene_id);
		}
		formData.append('element_id', element_id);
		formData.append('original_design', isOriginalDesign ? isOriginalDesign : false);
		formData.append('file', file);
		return this.http.post(this._gS.service_url + 'elements/add_image_to_brand', formData).pipe(map((response: Response) => response))
	}
	getBrandDetail(element_id) {
		let data = {
			session_id: this._gS.session_token,
			element_id: element_id,
		};
		return this.http.post(this._gS.service_url + 'elements/get_brand_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addSceneToElement(element_id, scene_id) {
		let data = {
			session_id: this._gS.session_token,
			element_id: element_id,
			scene_id: scene_id
		};
		return this.http.post(this._gS.service_url + 'elements/add_scene_to_element', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	editElement(element_id, values, project_id?) {
		let data = {
			session_id: this._gS.session_token,
			element_id: element_id,
			values: values,
			project_id: project_id ? project_id : undefined
		};
		return this.http.post(this._gS.service_url + 'elements/edit_element', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	createNewBrand(values, scene_id, project_id?) {
		let data = {
			session_id: this._gS.session_token,
			values: values,
			scene_id: scene_id,
			project_id: project_id ? project_id : undefined
		};
		return this.http.post(this._gS.service_url + 'elements/create_brand', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	sceneAddElement(project_id, scene_id, element_category_id, element_name) {
		let data = {
			project_id: project_id,
			session_id: this._gS.session_token,
			scene_id: scene_id,
			element_category_id: element_category_id,
			element_name: element_name,


		};
		return this.http.post(this._gS.service_url + 'scenes/add_element', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	sceneAddEvent(project_id, scene_id, event_type_id, event_name) {
		let data = {
			project_id: project_id,
			session_id: this._gS.session_token,
			scene_id: scene_id,
			event_type_id: event_type_id,
			event_name: event_name,


		};
		return this.http.post(this._gS.service_url + 'scenes/add_event', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	changeElementStatus(element_id, status_id) {
		let data = {
			session_id: this._gS.session_token,
			element_id: element_id,
			element_status_id: status_id
		};
		return this.http.post(this._gS.service_url + 'elements/change_element_status', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteElement(element_id) {
		let data = {
			session_id: this._gS.session_token,
			element_id: element_id
		};
		return this.http.post(this._gS.service_url + 'elements/delete_element', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteBrand(element_id) {
		let data = {
			session_id: this._gS.session_token,
			element_id: element_id
		};
		return this.http.post(this._gS.service_url + 'elements/delete_brand', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getBrands(project_id, order_by) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by
		};
		return this.http.post(this._gS.service_url + 'elements/get_brands', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getInterfaces(project_id, order_by) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by
		};
		return this.http.post(this._gS.service_url + 'elements/get_interfaces', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getSongs(project_id, order_by) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			order_by: order_by
		};
		return this.http.post(this._gS.service_url + 'elements/get_songs', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getEvents(project_id) {
		// get_events
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'events/get_events', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	editEvent(event_id, event_name, event_type_id, project_id) {
		// get_events
		let data = {
			session_id: this._gS.session_token,
			event_id: event_id,
			event_name: event_name,
			event_type_id: event_type_id,
			project_id: project_id

		};
		return this.http.post(this._gS.service_url + 'events/edit_event', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteEvent(event_id) {
		// get_events
		let data = {
			session_id: this._gS.session_token,
			event_id: event_id
		};
		return this.http.post(this._gS.service_url + 'events/delete_event', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getUnitsDetail(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'units/get_units', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getUnits(project_id) {
		return this.http.get(this._gS.service_url + 'post_production/get_units', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('project_id', project_id)
		})
	}

	deleteUnit(unit_id) {
		let data = {
			session_id: this._gS.session_token,
			unit_id: unit_id
		};
		return this.http.post(this._gS.service_url + 'units/delete_unit', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	uploadShootingTemplate(project_id, shooting_id, file, report_type) {
		let reportUrl = 'excel/';
		switch (report_type) {
			case 'script-template':
				reportUrl += 'read_report_shooting_schedule';
				break;
			case 'talent-template':
				reportUrl += 'read_talent_call';
				break;
			case 'crew-template':
				reportUrl += 'read_shooting_crew';
				break;
			case 'services-template':
				reportUrl += 'read_shooting_requirements';
				break;
		}

		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('project_id', project_id);
		formData.append('shooting_id', shooting_id);
		formData.append('file', file);
		return this.http.post(this._gS.service_url + reportUrl, formData).pipe(map((response: Response) => response))
	}

	getProjectMainData(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'projects/project_main_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createProjectCrew(project_id, values) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};

		Object.keys(values).forEach(
			property => data[property] = values[property]
		);

		return this.http.post(this._gS.service_url + 'projects/create_project_crew', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteProjectCrew(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'projects/delete_project_crew', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	changeStatusProjectCrew(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'projects/change_status_project_crew', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addImageToProject(img, project_id) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('project_id', project_id);
		formData.append('img', img);
		return this.http.post(this._gS.service_url + 'projects/upload_img_production', formData).pipe(map((response: Response) => response))
	}

	addImageToCharacter(img, id) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('id', id);
		formData.append('img', img);

		return this.http.post(this._gS.service_url + 'characters/upload_img_character', formData).pipe(map((response: Response) => response))
	}

	addImagesToLocation(img, id) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('id', id);
		formData.append('img', img);

		return this.http.post(this._gS.service_url + 'locations/upload_images_location', formData).pipe(map((response: Response) => response))
	}

	addImageToSet(img, id) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('id', id);
		formData.append('img', img);

		return this.http.post(this._gS.service_url + 'sets/upload_img_set', formData).pipe(map((response: Response) => response))
	}

	addImageToElement(img, id) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('id', id);
		formData.append('img', img);

		return this.http.post(this._gS.service_url + 'elements/upload_img_element', formData).pipe(map((response: Response) => response))
	}

	editContinuityImage(id: any, type: string, values: any) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			department_id: values.department_id,
			tittle: values.tittle,
			type: type
		};

		if (type == 'character') {
			data['character_id'] = values.character_id;
			data['day_of_history'] = values.day_of_history;
		} else if (type == 'set') {
			data['location_set_id'] = values.location_set_id;
			data['is_prop'] = values.is_prop;
		}

		return this.http.post(this._gS.service_url + 'continuity/edit_continuity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	editContinuitySceneImage(id, values: any) {
		let data = {
			session_id: this._gS.session_token,
			id,
			...values
		};

		return this.http.post(this._gS.service_url + 'continuity/create_scene_continuity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getContinuityLocationSets(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};

		return this.http.post(this._gS.service_url + 'continuity/get_location_sets', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getContinuityLocationSetsDetail(project_id, location_set_id) {
		let data = {
			session_id: this._gS.session_token,
			location_set_id: location_set_id,
			project_id: project_id,
		};

		return this.http.post(this._gS.service_url + 'continuity/get_location_sets_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBudget(project_id, budget_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			budget_id: budget_id
		};

		return this.http.post(this._gS.service_url + 'finance/delete_budget', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	characterDetail(project_id, character_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			character_id: character_id
		};
		return this.http.post(this._gS.service_url + 'characters/character_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	setDetail(project_id, set_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			set_id: set_id
		};
		return this.http.post(this._gS.service_url + 'sets/set_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addBrandObservation(values, element_id) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id ? values.id : null,
			observation: values.observation,
			element_id: element_id
		};
		return this.http.post(this._gS.service_url + 'elements/add_observation_brand', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBrandObservation(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'elements/delete_observation_brand', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addBrandFile(element_id, file) {
		let formData = new FormData();

		formData.append('session_id', this._gS.session_token);
		formData.append('element_id', element_id);
		formData.append('file', file);

		return this.http.post(this._gS.service_url + 'elements/add_file_brand', formData).pipe(map((response: Response) => response))
	}

	deleteFileBrand(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'elements/delete_file_brand', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addServiceShootingFile(service_id, file, project_id) {
		let formData = new FormData();

		formData.append('session_id', this._gS.session_token);
		formData.append('call_sheet_special_id', service_id);
		formData.append('file', file);
		formData.append('route', project_id);

		return this.http.post(this._gS.service_url + 'shooting_schedule/add_file_to_service', formData).pipe(map((response: Response) => response))
	}

	addCateringShootingFile(caterings, file, project_id) {
		let formData = new FormData();

		formData.append('session_id', this._gS.session_token);
		formData.append('caterings', caterings);
		formData.append('file', file);
		formData.append('route', project_id);

		return this.http.post(this._gS.service_url + 'shooting_schedule/upload_file_catering', formData).pipe(map((response: Response) => response))
	}

	deleteFileCatering(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_file_catering', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getColorBoxEpisodes(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'post_production/get_color_box_episode', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getScenesShooting(date, unit_id) {
		return this.http.get(this._gS.service_url + 'post_production/get_scenes_daily_plan', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('date', date)
				.set('unit_id', unit_id)
		})
	}

	submitShootingSchedule(shooting_schedules_id, sh_submit_type_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_schedules_id: shooting_schedules_id,
			sh_submit_type_id: sh_submit_type_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/shooting_schedule_submit', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	unpublishShootingSchedule(shooting_schedules_id, sh_submit_type_id) {
		let data = {
			session_id: this._gS.session_token,
			shooting_schedules_id: shooting_schedules_id,
			sh_submit_type_id: sh_submit_type_id
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/shooting_schedule_unpublish', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	saveBulkScene(project_id, scenes_ids, values) {
		let data = {
			scenes_ids: scenes_ids,
			project_id: project_id,
			values: values,
			session_id: this._gS.session_token,
		};
		return this.http.post(this._gS.service_url + 'scenes/edit_scene_multiple', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	saveProjectGoals(project_id, values) {
		let data = {
			project_id: project_id,
			scenes_per_chapter: values.scenes_per_chapter,
			pages_per_chapter: values.pages_per_chapter,
			projected_days: values.projected_days,
			projected_shooting: values.projected_shooting,
			session_id: this._gS.session_token,
		};
		return this.http.post(this._gS.service_url + 'projects/save_goal', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	saveDrawingNote(drawing_id, id, note, isShooting: boolean, user_id = undefined) {
		let data = {
			id: drawing_id,
			session_id: this._gS.session_token,
			shooting_schedule_id: isShooting ? id : undefined,
			scene_id: isShooting ? undefined : id,
			user_id: user_id,
			json: note
		};
		let url = isShooting ? 'shooting_schedule/add_drawing_note' : 'scenes/add_drawing_note';
		return this.http.post(this._gS.service_url + url, data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteDrawingNote(drawing_id) {
		let data = {
			session_id: this._gS.session_token,
			drawing_note_id: drawing_id,
		};
		return this.http.post(this._gS.service_url + 'scenes/delete_drawing_note', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	sceneAddCharacter(project_id, scene_id, character_role_id, character_name, quantity) {
		let data = {
			project_id: project_id,
			session_id: this._gS.session_token,
			scene_id: scene_id,
			character_role_id: character_role_id,
			character_name: character_name,
			quantity: quantity
		};
		return this.http.post(this._gS.service_url + 'scenes/add_character', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	shootingAddBanner(params) {
		let data = {
			session_id: this._gS.session_token,
			shooting_id: params.shooting_id,
			description: params.description,
			scene_shooting_id: params.scene_shooting_id,
			type_array: params.type_array,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/add_sc_sch_banners', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	shootingEditBanner(params) {
		let data = {
			session_id: this._gS.session_token,
			banner_id: params.bannerId,
			description: params.description,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/add_sc_sch_banners', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	shootingDeleteBanner(params) {
		let data = {
			session_id: this._gS.session_token,
			banner_id: params.bannerId,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_sc_sch_banners', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	locationDetail(projectId, locationId) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			location_id: locationId
		};
		return this.http.post(this._gS.service_url + 'locations/location_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	elementDetail(projectId, elementId) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			element_id: elementId
		};
		return this.http.post(this._gS.service_url + 'elements/element_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getUnitDetail(unitId) {
		let data = {
			session_id: this._gS.session_token,
			unit_id: unitId
		}
		return this.http.post(this._gS.service_url + 'projects/live_view_unit', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteHospital(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		}
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_hospital', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	setDataProjectPages(list) {
		console.log("/")
		console.log(list)
		let daysWork = 0;
		list.map((item: any) => {
			item.project_weeks.map((we: any) => {
				we.days.map((dy: any) => {
					let day = dy.day_work.toString().toLowerCase();
					if (day == 'sw') {
						item['start_work'] = dy.date;
						daysWork++;
					} 
					if (day == 'w') daysWork++;
					if (day == 'wf') {
						item['finish_work'] = dy.date;
						daysWork++;
					}
					if (day == 'swf') {
						item['start_work'] = dy.date;
						item['finish_work'] = dy.date;
						daysWork++;
					}
				})
			})
		});
		list[0]['days_work'] = daysWork; 
	}

	editCharacterChange(values) {
		let data = {
			session_id: this._gS.session_token,
			scene_id: values.scene_id,
			character_id: values.character_id,
			wd_change: values.wd_change,
			wd_comment: values.wd_comment,
			change_for_day: values.change_for_day
		}
		return this.http.post(this._gS.service_url + 'scenes/save_wd_change', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getUnitsShoo(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		}
		return this.http.post(this._gS.service_url + 'shooting_schedule/units_with_shooting_schedules', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	moveScenesToSho(project_id, values, scenes) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			shooting_schedule_id: values.shooting_id,
			unit_id: values.unit_id,
			ids: scenes
		}
		return this.http.post(this._gS.service_url + 'shooting_schedule/move_scenes_between_shootings', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	changeLocStudio(shooting_id, id) {
		//Pending back
		let data = {
			session_id: this._gS.session_token,
			shooting_id: shooting_id,
			location_or_type_of_studies_id: id
		}
		return this.http.post(this._gS.service_url + 'shooting_schedule/save_location_or_study', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteNotUsedCharacters(project_id){
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		}
		return this.http.post(this._gS.service_url + 'characters/delete_not_used', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteNotUsedElements(project_id){
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		}
		return this.http.post(this._gS.service_url + 'elements/delete_not_used', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteNotUsedSets(project_id){
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		}
		return this.http.post(this._gS.service_url + 'sets/delete_not_used', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteNotUsedLocations(project_id){
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		}
		return this.http.post(this._gS.service_url + 'locations/delete_not_used', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteNotUsedEvents(project_id){
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		}
		return this.http.post(this._gS.service_url + 'events/delete_not_used', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	constructor(private _cS: CookieService, private http: HttpClient, public _gS: GlobalService, private _dP: DatePipe) { }
}
